/** @type {import('tailwindcss').Config} */
module.exports = {
  content: [
    './app/**/*.{js,ts,jsx,tsx}',
    './components/**/*.{js,ts,jsx,tsx}',
    './utils/**/*.{js,ts,jsx,tsx}',
  ],
  safelist: [],
  theme: {
    screens: {
      xs: '540px',
      md: '768px',
      lg: '1024px',
      xl: '1440px',
      '2xl': '1920px',
    },
    extend: {
      container: {
        screens: {
          lg: '1024px',
          xl: '1440px',
          sxl: '1800px',
          '2xl': '1920px',
        },
      },
      colors: {
        primary: {
          DEFAULT: '#005096',
          medium: '#009fde',
          light: '#dbeeff',
        },
        secondary: {
          DEFAULT: '#d23c2d',
          light: '#faebea',
        },
        mosque: {
          DEFAULT: '#036579',
          light: '#d9f8fe',
        },
        purple: {
          DEFAULT: '#8b0f77',
          light: '#fcdff7',
        },
        orange: {
          DEFAULT: '#f18a00',
          light: '#fff3e4',
        },
        green: {
          DEFAULT: '#34c17b',
          light: '#d5f4e5',
        },
        live: {
          DEFAULT: '#005096',
          light: '#dbeeff',
        },
        blue: {
          DEFAULT: '#009fde',
          light: '#a8d1ec',
        },
        red: {
          DEFAULT: '#e34545',
          light: '#f1a2a2',
        },
        glacial: {
          DEFAULT: '#397dbe',
          light: '#9abee1',
        },
        brown: {
          DEFAULT: '#644117',
          light: '#f2e6d9',
        },
        pink: {
          DEFAULT: '#d998a0',
          light: '#fff0f5',
        },
        yellow: {
          DEFAULT: '#f3e03b',
          light: '#fff8e1',
        },
        ivory: {
          DEFAULT: '#CFC3AD',
          light: '#FFFDF7',
        },
        light: '#d4d6da',
      },
      fontSize: {
        headline: '4rem',
      },
      borderRadius: {
        DEFAULT: '0.5rem',
      },
    },
  },
}
